import { render, staticRenderFns } from "./SubServiceItem.vue?vue&type=template&id=5b03c4c4&scoped=true&"
import script from "./SubServiceItem.vue?vue&type=script&lang=ts&"
export * from "./SubServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./SubServiceItem.vue?vue&type=style&index=0&id=5b03c4c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03c4c4",
  null
  
)

export default component.exports